module.exports = __webpack_public_path__ + "img/img_join_01.41756ada.jpg";